import React, { useEffect, useState } from 'react';
import { getListMentorsByChallenge, getListMentorsByBounty, addMentorToChallenge, inactiveMentorToChallenge, deleteMentorToChallenge, getListEvaluations, createRound, getListRound, editRound, deleteRound, getSubmissionRound } from '../../../../../redux/actions/daoUI/challenges.action';

const ChallengeFullDetailModal = ({ challenge, bountyId, onClose }) => {
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddMentorModal, setShowAddMentorModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState('');
  const [availableMentors, setAvailableMentors] = useState([]);
  const [loadingMentors, setLoadingMentors] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [mentorToUpdate, setMentorToUpdate] = useState(null);
  const [statusNote, setStatusNote] = useState('');
  const [newStatus, setNewStatus] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [mentorToDelete, setMentorToDelete] = useState(null);
  const [showAddRoundModal, setShowAddRoundModal] = useState(false);
  const [roundName, setRoundName] = useState('');
  const [evaluation, setEvaluation] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [evaluations, setEvaluations] = useState([]);
  const [loadingEvaluations, setLoadingEvaluations] = useState(false);
  const [rounds, setRounds] = useState([]);
  const [loadingRounds, setLoadingRounds] = useState(false);
  const [selectedRound, setSelectedRound] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [roundStatus, setRoundStatus] = useState('INPROGRESS');
  const [showDeleteRoundModal, setShowDeleteRoundModal] = useState(false);
  const [roundToDelete, setRoundToDelete] = useState(null);
  const [showRoundDetailModal, setShowRoundDetailModal] = useState(false);
  const [roundToView, setRoundToView] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [loadingSubmissions, setLoadingSubmissions] = useState(false);
  
  useEffect(() => {
    const fetchMentors = async () => {
      if (!challenge?._id) return;
      
      setLoading(true);
      try {
        const params = { 
          challengeId: challenge._id, 
          page: 1, 
          limit: 10 
        };
        const response = await getListMentorsByChallenge(params)();
        if (response?.data) {
          setMentors(response.data);
        }
      } catch (error) {
        console.error("Lỗi khi lấy danh sách mentor:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchMentors();
    fetchRounds();
  }, [challenge]);
  
  const fetchAvailableMentors = async () => {
    if (!bountyId) return;
    
    setLoadingMentors(true);
    try {
      const params = { bountyId };
      const response = await getListMentorsByBounty(params)();
      console.log('Available mentors response:', response);
      if (response?.data) {
        setAvailableMentors(response.data);
      }
    } catch (error) {
      console.error("Lỗi khi lấy danh sách mentor khả dụng:", error);
    } finally {
      setLoadingMentors(false);
    }
  };

  const fetchEvaluations = async () => {
    setLoadingEvaluations(true);
    try {
      const response = await getListEvaluations()();
      if (response?.data) {
        setEvaluations(response.data);
      }
    } catch (error) {
      console.error("Lỗi khi lấy danh sách evaluations:", error);
    } finally {
      setLoadingEvaluations(false);
    }
  };
  
  const fetchRounds = async () => {
    if (!challenge?._id) return;
    
    setLoadingRounds(true);
    try {
      const params = { 
        challengeId: challenge._id, 
        page: 1, 
        limit: 100 
      };
      const response = await getListRound(params)();
      if (response?.data) {
        setRounds(response.data);
      }
    } catch (error) {
      console.error("Lỗi khi lấy danh sách rounds:", error);
    } finally {
      setLoadingRounds(false);
    }
  };
  
  const handleOpenAddMentorModal = () => {
    setShowAddMentorModal(true);
    fetchAvailableMentors();
  };

  const handleAddMentor = async () => {
    if (!selectedMentor) return;
    
    try {
      const mentorData = {
        bountyId: bountyId,
        challengeId: challenge._id,
        mentorId: selectedMentor
      };
      
      const result = await addMentorToChallenge(mentorData)();
      
      if (result) {
        // Reload mentors list after successful addition
        const params = { 
          challengeId: challenge._id, 
          page: 1, 
          limit: 10 
        };
        const response = await getListMentorsByChallenge(params)();
        if (response?.data) {
          setMentors(response.data);
        }
        
        setShowAddMentorModal(false);
        setSelectedMentor('');
      } else {
        console.error('Failed to add mentor');
      }
    } catch (error) {
      console.error('Error adding mentor:', error);
    }
  };

  const handleOpenStatusModal = (mentor) => {
    const targetStatus = mentor.status === 'INACTIVE' ? 'ACTIVE' : 'INACTIVE';
    setMentorToUpdate(mentor);
    setNewStatus(targetStatus);
    setStatusNote('');
    setShowStatusModal(true);
  };

  const handleUpdateMentorStatus = async () => {
    if (!mentorToUpdate) return;
    
    try {
      const mentorData = {
        id: mentorToUpdate._id,
        note: statusNote,
        status: newStatus
      };
      
      const result = await inactiveMentorToChallenge(mentorData)();
      
      if (result) {
        // Reload mentors list after successful status update
        const params = { 
          challengeId: challenge._id, 
          page: 1, 
          limit: 10 
        };
        const response = await getListMentorsByChallenge(params)();
        if (response?.data) {
          setMentors(response.data);
        }
        
        setShowStatusModal(false);
        setMentorToUpdate(null);
        setStatusNote('');
        setNewStatus('');
      } else {
        console.error('Failed to update mentor status');
      }
    } catch (error) {
      console.error('Error updating mentor status:', error);
    }
  };

  const handleOpenDeleteModal = (mentor) => {
    setMentorToDelete(mentor);
    setShowDeleteModal(true);
  };

  const handleDeleteMentor = async () => {
    if (!mentorToDelete) return;
    
    try {
      const mentorData = {
        id: mentorToDelete._id
      };
      
      const result = await deleteMentorToChallenge(mentorData)();
      
      if (result) {
        // Reload mentors list after successful deletion
        const params = { 
          challengeId: challenge._id, 
          page: 1, 
          limit: 10 
        };
        const response = await getListMentorsByChallenge(params)();
        if (response?.data) {
          setMentors(response.data);
        }
        
        setShowDeleteModal(false);
        setMentorToDelete(null);
      } else {
        console.error('Failed to delete mentor');
      }
    } catch (error) {
      console.error('Error deleting mentor:', error);
    }
  };

  const handleOpenAddRoundModal = () => {
    setShowAddRoundModal(true);
    setRoundName('');
    setEvaluation('');
    setStartDate('');
    setEndDate('');
    setRoundStatus('INPROGRESS');
    setIsEditMode(false);
    setSelectedRound(null);
    fetchEvaluations();
  };

  const handleAddRound = async () => {
    try {
      if (isEditMode) {
        // Xử lý chỉnh sửa round
        const data = {
          _id: selectedRound._id,
          bountyId: bountyId,
          challengeId: challenge._id,
          name: roundName,
          evaluationId: evaluation,
          startDate: new Date(startDate).toISOString(),
          endDate: new Date(endDate).toISOString(),
          status: roundStatus
        };
        
        const result = await editRound(selectedRound._id, data)();
        
        if (result) {
          setShowAddRoundModal(false);
          fetchRounds(); // Cập nhật danh sách rounds sau khi sửa thành công
        } else {
          console.error('Không thể sửa round');
        }
      } else {
        // Xử lý thêm mới round
        const data = {
          bountyId: bountyId,
          challengeId: challenge._id,
          name: roundName,
          evaluationId: evaluation,
          startDate: new Date(startDate).getTime(),
          endDate: new Date(endDate).getTime()
        };
        
        const result = await createRound(data)();
        
        if (result) {
          setShowAddRoundModal(false);
          fetchRounds(); // Cập nhật danh sách rounds sau khi thêm thành công
        } else {
          console.error('Không thể tạo round');
        }
      }
    } catch (error) {
      console.error('Lỗi khi xử lý round:', error);
    }
  };

  const handleOpenEditRoundModal = (round) => {
    setSelectedRound(round);
    setRoundName(round.name);
    setEvaluation(round.evaluation?._id || round.evaluationId);
    const startDateObj = new Date(round.startDate);
    const endDateObj = new Date(round.endDate);
    setStartDate(startDateObj.toISOString().slice(0, 16));
    setEndDate(endDateObj.toISOString().slice(0, 16));
    setRoundStatus(round.status || 'INPROGRESS');
    setIsEditMode(true);
    setShowAddRoundModal(true);
    fetchEvaluations();
  };

  const handleOpenDeleteRoundModal = (round) => {
    setRoundToDelete(round);
    setShowDeleteRoundModal(true);
  };

  const handleDeleteRound = async () => {
    if (!roundToDelete) return;
    
    try {
      const result = await deleteRound(roundToDelete._id)();
      
      if (result) {
        // Reload rounds list after successful deletion
        fetchRounds();
        setShowDeleteRoundModal(false);
        setRoundToDelete(null);
      } else {
        console.error('Failed to delete round');
      }
    } catch (error) {
      console.error('Error deleting round:', error);
    }
  };

  const handleOpenRoundDetailModal = async (round) => {
    setRoundToView(round);
    setShowRoundDetailModal(true);
    
    // Fetch submissions for this round
    if (round?._id) {
      setLoadingSubmissions(true);
      try {
        const params = { roundId: round._id };
        const response = await getSubmissionRound(params)();
        if (response?.data) {
          setSubmissions(response.data);
        } else {
          setSubmissions([]);
        }
      } catch (error) {
        console.error("Error fetching round submissions:", error);
        setSubmissions([]);
      } finally {
        setLoadingSubmissions(false);
      }
    }
  };

  if (!challenge) return null;

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001
    }}>
      {/* Add/Edit Round Modal */}
      {showAddRoundModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1002
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            width: '600px',
            padding: '20px',
            position: 'relative'
          }}>
            <h3 style={{ 
              marginBottom: '20px',
              fontSize: '20px',
              fontWeight: 'bold'
            }}>
              {isEditMode ? 'Edit round' : 'Add round'}
            </h3>
            
            <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
              <div style={{ flex: 1 }}>
                <input 
                  type="text"
                  placeholder="Round name *"
                  value={roundName}
                  onChange={(e) => setRoundName(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    outline: 'none'
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{
                  width: '100%',
                  position: 'relative'
                }}>
                  <select
                    value={evaluation}
                    onChange={(e) => setEvaluation(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                      outline: 'none',
                      appearance: 'none'
                    }}
                    disabled={loadingEvaluations}
                  >
                    <option value="" disabled>Evaluation *</option>
                    {loadingEvaluations ? (
                      <option value="" disabled>Đang tải...</option>
                    ) : (
                      evaluations.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.name}
                        </option>
                      ))
                    )}
                  </select>
                  <div style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none'
                  }}>
                    ▼
                  </div>
                </div>
              </div>
            </div>
            
            <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
              <div style={{ flex: 1 }}>
                <div style={{
                  width: '100%',
                  position: 'relative'
                }}>
                  <input 
                    type={isEditMode ? 'datetime-local' : 'text'}
                    placeholder="Start Date *"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                      outline: 'none'
                    }}
                    onFocus={(e) => {if (!isEditMode) e.target.type = 'datetime-local'}}
                    onBlur={(e) => {if (!isEditMode && !e.target.value) e.target.type = 'text'}}
                  />
                  <div style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none'
                  }}>
                    📅
                  </div>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{
                  width: '100%',
                  position: 'relative'
                }}>
                  <input 
                    type={isEditMode ? 'datetime-local' : 'text'}
                    placeholder="End Date *"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                      outline: 'none'
                    }}
                    onFocus={(e) => {if (!isEditMode) e.target.type = 'datetime-local'}}
                    onBlur={(e) => {if (!isEditMode && !e.target.value) e.target.type = 'text'}}
                  />
                  <div style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none'
                  }}>
                    📅
                  </div>
                </div>
              </div>
            </div>

            {isEditMode && (
              <div style={{ marginBottom: '20px' }}>
                <div style={{
                  width: '100%',
                  position: 'relative'
                }}>
                  <select
                    value={roundStatus}
                    onChange={(e) => setRoundStatus(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                      outline: 'none',
                      appearance: 'none'
                    }}
                  >
                    <option value="INPROGRESS">INPROGRESS</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="CANCELED">CANCELED</option>
                  </select>
                  <div style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none'
                  }}>
                    ▼
                  </div>
                </div>
              </div>
            )}
            
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <button
                onClick={() => setShowAddRoundModal(false)}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  color: '#666',
                  fontWeight: 'bold'
                }}
              >
                CANCEL
              </button>
              <button
                onClick={handleAddRound}
                disabled={!isEditMode && (!roundName || !evaluation || !startDate || !endDate)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: (isEditMode || (roundName && evaluation && startDate && endDate)) ? '#0052cc' : '#ccc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: (isEditMode || (roundName && evaluation && startDate && endDate)) ? 'pointer' : 'not-allowed',
                  fontWeight: 'bold'
                }}
              >
                {isEditMode ? 'SAVE' : 'ADD'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Mentor Modal */}
      {showDeleteModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1002
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            width: '400px',
            padding: '20px',
            position: 'relative'
          }}>
            <h3 style={{ 
              textAlign: 'center', 
              marginBottom: '20px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              Are you sure you want to delete this mentor?
            </h3>
            
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  color: '#666'
                }}
              >
                CANCEL
              </button>
              <button
                onClick={handleDeleteMentor}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                DELETE
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Status Change Modal */}
      {showStatusModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1002
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            width: '400px',
            padding: '20px',
            position: 'relative'
          }}>
            <h3 style={{ 
              textAlign: 'center', 
              marginBottom: '20px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              {newStatus === 'INACTIVE' 
                ? 'Do you wanna inactive this mentor?' 
                : 'Do you wanna activate this mentor?'}
            </h3>
            
            <div style={{ marginBottom: '20px' }}>
              <input 
                type="text"
                placeholder="Enter the reason"
                value={statusNote}
                onChange={(e) => setStatusNote(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  outline: 'none'
                }}
              />
            </div>
            
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <button
                onClick={() => setShowStatusModal(false)}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  color: '#666'
                }}
              >
                NO
              </button>
              <button
                onClick={handleUpdateMentorStatus}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#0052cc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                YES
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Mentor Modal */}
      {showAddMentorModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1002
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            width: '400px',
            padding: '20px',
            position: 'relative'
          }}>
            <h3 style={{ 
              textAlign: 'center', 
              marginBottom: '20px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              Add mentor to follow the team challenge
            </h3>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold', color: '#0052cc' }}>
                Choose Mentor
              </label>
              <select 
                value={selectedMentor}
                onChange={(e) => setSelectedMentor(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  outline: 'none'
                }}
                disabled={loadingMentors}
              >
                <option value="">Chọn mentor</option>
                {loadingMentors ? (
                  <option value="" disabled>Đang tải...</option>
                ) : (
                  availableMentors.map((mentor) => (
                    <option key={mentor._id} value={mentor._id}>
                      {mentor.name} ({mentor.email})
                    </option>
                  ))
                )}
              </select>
            </div>
            
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <button
                onClick={() => setShowAddMentorModal(false)}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  color: '#666'
                }}
              >
                CANCEL
              </button>
              <button
                onClick={handleAddMentor}
                disabled={!selectedMentor || loadingMentors}
                style={{
                  padding: '8px 16px',
                  backgroundColor: selectedMentor && !loadingMentors ? '#0052cc' : '#ccc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: selectedMentor && !loadingMentors ? 'pointer' : 'not-allowed'
                }}
              >
                ADD
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Round Modal */}
      {showDeleteRoundModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1002
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            width: '400px',
            padding: '20px',
            position: 'relative'
          }}>
            <h3 style={{ 
              textAlign: 'center', 
              marginBottom: '20px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}>
              Are you sure you want to delete this round?
            </h3>
            
            <div style={{ 
              display: 'flex', 
              justifyContent: 'flex-end',
              gap: '10px'
            }}>
              <button
                onClick={() => setShowDeleteRoundModal(false)}
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  color: '#666'
                }}
              >
                CANCEL
              </button>
              <button
                onClick={handleDeleteRound}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                DELETE
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Round Detail Modal */}
      {showRoundDetailModal && roundToView && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1002
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            width: '90%',
            maxWidth: '1000px',
            maxHeight: '90vh',
            overflow: 'auto',
            padding: '30px',
            position: 'relative'
          }}>
            <button
              onClick={() => setShowRoundDetailModal(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >×</button>

            <h2 style={{ color: '#03edc3', marginBottom: '20px' }}>Round Detail</h2>
            
            {/* Round Information */}
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{ color: '#232b5b', marginBottom: '15px' }}>Round Information</h3>
              <div style={{ 
                backgroundColor: '#f5f5f5', 
                padding: '20px', 
                borderRadius: '8px',
                border: '1px solid #e0e0e0'
              }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                  <div>
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Name:</div>
                    <div>{roundToView.name}</div>
                  </div>
                  <div>
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Status:</div>
                    <span style={{ 
                      backgroundColor: '#ffebee', 
                      color: '#c62828', 
                      padding: '4px 8px', 
                      borderRadius: '20px',
                      fontSize: '0.8em'
                    }}>
                      {roundToView.status || 'INPROGRESS'}
                    </span>
                  </div>
                  <div>
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Start Date:</div>
                    <div>{new Date(roundToView.startDate).toLocaleString()}</div>
                  </div>
                  <div>
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>End Date:</div>
                    <div>{new Date(roundToView.endDate).toLocaleString()}</div>
                  </div>
                  <div>
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Evaluation:</div>
                    <div>{roundToView.evaluation?.name || 'No evaluation'}</div>
                  </div>
                  <div>
                    <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Challenge:</div>
                    <div>{challenge.name}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Submissions */}
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{ color: '#232b5b', marginBottom: '15px' }}>Submissions</h3>
              <div style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.08)', borderRadius: '6px', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Team Name</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Team Lead Email</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Link</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Presentation</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Demo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingSubmissions ? (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                            <div style={{
                              width: '20px',
                              height: '20px',
                              border: '2px solid #f3f3f3',
                              borderTop: '2px solid #232b5b',
                              borderRadius: '50%',
                              animation: 'spin 1s linear infinite'
                            }}></div>
                            Loading submissions...
                          </div>
                        </td>
                      </tr>
                    ) : submissions.length > 0 ? (
                      submissions.map((submission, index) => (
                        <tr key={submission.id || index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                          <td style={{ padding: '12px', verticalAlign: 'top' }}>
                            <div style={{ fontWeight: '500', color: '#232b5b' }}>
                              {submission.teamName || 'N/A'}
                            </div>
                            <div style={{ fontSize: '0.85em', color: '#666', marginTop: '2px' }}>
                              {submission.challengeName || challenge.name}
                            </div>
                          </td>
                          <td style={{ padding: '12px', verticalAlign: 'top' }}>
                            <div style={{ color: '#232b5b' }}>
                              {submission.teamLeadEmail || 'N/A'}
                            </div>
                          </td>
                          <td style={{ padding: '12px', verticalAlign: 'top' }}>
                            {submission.link ? (
                              <a 
                                href={submission.link} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ 
                                  color: '#03edc3', 
                                  textDecoration: 'none',
                                  fontWeight: '500'
                                }}
                                onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                              >
                                View Link
                              </a>
                            ) : (
                              <span style={{ color: '#999' }}>N/A</span>
                            )}
                          </td>
                          <td style={{ padding: '12px', verticalAlign: 'top' }}>
                            {submission.presentation ? (
                              <a 
                                href={submission.presentation} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ 
                                  color: '#03edc3', 
                                  textDecoration: 'none',
                                  fontWeight: '500'
                                }}
                                onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                              >
                                View Presentation
                              </a>
                            ) : (
                              <span style={{ color: '#999' }}>N/A</span>
                            )}
                          </td>
                          <td style={{ padding: '12px', verticalAlign: 'top' }}>
                            {submission.demo ? (
                              <a 
                                href={submission.demo} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{ 
                                  color: '#03edc3', 
                                  textDecoration: 'none',
                                  fontWeight: '500'
                                }}
                                onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                                onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                              >
                                View Demo
                              </a>
                            ) : (
                              <span style={{ color: '#999' }}>N/A</span>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                          No submissions available for this round
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <div style={{
        backgroundColor: '#fff',
        borderRadius: '10px',
        width: '90%',
        maxWidth: '1200px',
        maxHeight: '90vh',
        overflow: 'auto',
        padding: '30px',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >×</button>

        <h2 style={{ color: '#03edc3', marginBottom: '20px' }}>Challenge Detail</h2>
        
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ color: '#232b5b' }}>Challenge Detail</h3>
          <div style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '15px', 
            borderRadius: '8px',
            border: '1px solid #e0e0e0',
            marginTop: '10px'
          }}>
            <div style={{ display: 'flex', marginBottom: '10px' }}>
              <div style={{ width: '100px', fontWeight: 'bold' }}>Name:</div>
              <div>{challenge.name}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ width: '100px', fontWeight: 'bold' }}>Type:</div>
              <div>{challenge.type}</div>
            </div>
          </div>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ color: '#232b5b' }}>Mentors</h3>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
            <button
              onClick={handleOpenAddMentorModal}
              style={{
                padding: '6px 12px',
                backgroundColor: '#232b5b',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              ADD MENTOR
            </button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Mentor</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Note</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '15px' }}>Đang tải...</td>
                </tr>
              ) : mentors.length > 0 ? (
                mentors.map((mentor, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <td style={{ padding: '12px' }}>
                      <div>{mentor?.mentor?.name || 'Chưa có tên'}</div>
                      <div style={{ color: '#666', fontSize: '0.9em' }}>{mentor?.mentor?.email || 'Chưa có email'}</div>
                    </td>
                    <td style={{ padding: '12px', color: mentor.status === 'INACTIVE' ? 'red' : 'green' }}>{mentor.status || 'ACTIVE'}</td>
                    <td style={{ padding: '12px' }}>{mentor.note || ''}</td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      {mentor.status === 'INACTIVE' ? (
                        <button
                          style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '5px' }}
                          onClick={() => handleOpenStatusModal(mentor)}
                        >
                          <span style={{ color: 'blue', fontSize: '16px' }}>🔄</span>
                        </button>
                      ) : (
                        <button
                          style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '5px' }}
                          onClick={() => handleOpenStatusModal(mentor)}
                        >🔗
                        </button>
                      )}
                      <button 
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'red' }}
                        onClick={() => handleOpenDeleteModal(mentor)}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '15px', color: '#666' }}>No Data</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ color: '#232b5b' }}>Teams</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Introduction</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Urgent Contact</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Proposal Link</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', padding: '15px', color: '#666' }}>No data</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ marginBottom: '10px' }}>
          <h3 style={{ color: '#232b5b' }}>Rounds</h3>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
            <button
              onClick={handleOpenAddRoundModal}
              style={{
                padding: '6px 12px',
                backgroundColor: '#232b5b',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              ADD ROUND
            </button>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Status</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Start Time</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>End Time</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Evaluation</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loadingRounds ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '15px' }}>Đang tải...</td>
                </tr>
              ) : rounds.length > 0 ? (
                rounds.map((round, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <td style={{ padding: '12px' }}>{round.name}</td>
                    <td style={{ padding: '12px' }}>
                      <span style={{ 
                        backgroundColor: '#ffebee', 
                        color: '#c62828', 
                        padding: '4px 8px', 
                        borderRadius: '20px',
                        fontSize: '0.8em'
                      }}>
                        {round.status || 'INPROGRESS'}
                      </span>
                    </td>
                    <td style={{ padding: '12px' }}>{new Date(round.startDate).toLocaleString()}</td>
                    <td style={{ padding: '12px' }}>{new Date(round.endDate).toLocaleString()}</td>
                    <td style={{ padding: '12px' }}>{round.evaluation?.name || 'Không có'}</td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      <button 
                        style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '5px' }}
                        onClick={() => handleOpenRoundDetailModal(round)}
                      >👁️</button>
                      <button 
                        style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '5px' }}
                        onClick={() => handleOpenEditRoundModal(round)}
                      >✏️</button>
                      <button 
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'red' }}
                        onClick={() => handleOpenDeleteRoundModal(round)}
                      >🗑️</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '15px', color: '#666' }}>No Data</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div>
          <h3 style={{ color: '#232b5b' }}>Reminder Management</h3>
          <div style={{ marginTop: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.08)', borderRadius: '6px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #e0e0e0', background: '#fff' }}>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>Mentor</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>Team</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>Challenge / Round</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>Evaluation</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>Submission</th>
                  <th style={{ padding: '16px', textAlign: 'left', fontWeight: 600 }}>Due Date</th>
                </tr>
              </thead>
              <tbody>
                {/* Hiện tại chưa có dữ liệu, để trống */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ChallengeFullDetailModal;
